import React from 'react'

// Note: all Touch Experience title URLs should always go to this page
// according to the direction of the content team
const TOUCH_EXPERIENCE_URL = '/experiences/touch-experiences'

const AnimalEncounters = ({ encounters }) => {
  return (
    <div className="container mb-24 md:mb-60 md:text-center">
      <h2 className="md:text-center">Touch Experiences</h2>

      <div className="md:flex md:justify-around">
        {encounters.map(({ title, availability }) => (
          <dl
            key={title}
            className="leading-normal md:flex-1 md:px-16 md:text-center"
          >
            <dt className="font-bold text-depths">
              <a
                href={TOUCH_EXPERIENCE_URL}
                className="text-depths no-underline"
              >
                {title}
              </a>
            </dt>
            <dd>{availability}</dd>
          </dl>
        ))}
      </div>
    </div>
  )
}

export default AnimalEncounters
